var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedpikug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.265625,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#95B0B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6361 4.11462H14.8933V6.96082C13.3741 7.1913 11.9297 7.80231 10.699 8.74668C9.1023 9.97187 7.95449 11.6897 7.43359 13.6337L10.0829 14.3436C10.4475 12.9828 11.251 11.7803 12.3687 10.9227C13.1183 10.3475 13.9812 9.94892 14.8933 9.74882V14.6581H12.6076V17.4008H14.8933V22.2404C13.9812 22.0403 13.1184 21.6417 12.3687 21.0665C11.251 20.2089 10.4476 19.0064 10.083 17.6456L7.43364 18.3555C7.95453 20.2995 9.10234 22.0173 10.699 23.2425C11.9298 24.1869 13.3742 24.7979 14.8933 25.0284V27.8853H17.6361V25.0284C19.1552 24.7979 20.5996 24.1869 21.8303 23.2425C23.427 22.0173 24.5748 20.2995 25.0957 18.3555L22.4464 17.6456C22.0818 19.0064 21.2783 20.2089 20.1606 21.0665C19.411 21.6418 18.5481 22.0403 17.6361 22.2404V17.4008H19.9217V14.6581H17.6361V9.74883C18.5481 9.94893 19.411 10.3475 20.1606 10.9227C21.2783 11.7803 22.0817 12.9828 22.4464 14.3436L25.0957 13.6337C24.5748 11.6897 23.427 9.97187 21.8303 8.74668C20.5996 7.80232 19.1552 7.19131 17.6361 6.96083V4.11462Z",
    fill: "#010304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedpikug);
export default __webpack_public_path__ + "static/media/lockedpikug.df6fbfb2e1aa99786e63629d23b7ec4b.svg";
export { ForwardRef as ReactComponent };